import Lottie from 'lottie-react'
import React, { useState } from 'react'
import Fan from '../Animation/fan.json'
import { FaArrowRight } from 'react-icons/fa'

const GetInTouch = ({ showModal }) => {
  const [formData, setFormData] = useState({
    name: '',
    mobile: '',
    email: '',
    subject: '',
    message: '',
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const { name, mobile, email, subject, message } = formData;

    // Prepare a nice WhatsApp message
    const whatsappMessage = `Hello! 👋
I would like to get in touch. Here are my details:

🔹 Name: ${name}
🔹 Mobile Number: ${mobile}
🔹 Email: ${email}
🔹 Subject: ${subject}
🔹 Message: ${message}

Please get back to me. Thank you! 🙏`;

    // Encode message for URL
    const encodedMessage = encodeURIComponent(whatsappMessage);

    // WhatsApp URL
    const whatsappURL = `https://wa.me/919211266200?text=${encodedMessage}`;

    // Open WhatsApp
    window.open(whatsappURL, '_blank');
  };

  return (
    <div
    className={`w-full ${showModal ? 'py-2' : 'sm:py-24'}`}
    style={
      showModal
        ? {}
        : {
            backgroundImage: `url("/get_a_quote_bg.jpg")`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
          }
    }
  >  
      <div className='w-full max-w-6xl mx-auto px-4 flex flex-col lg:flex-row items-center gap-10'>
        {/* Left Image */}
        <div className={`w-full lg:w-[450px] ${showModal ? 'hidden' : ''}`}>
          <img
            src='/get_a_quote_img.webp'
            className='w-full h-auto rounded-md shadow-md'
            alt='Get a Quote'
          />
        </div>

        {/* Right Side Form */}
        <div className={`w-full ${showModal ? '' : 'lg:w-1/2'}`}>
          <div className='flex items-center gap-2 mb-4'>
            <Lottie className='w-6' animationData={Fan} />
            <h1 className={`sm:text-2xl text-xl text-orange-500 font-bold uppercase ${showModal ? 'hidden' : ''}`}>Get in touch</h1>
          </div>
          <p className={`text-2xl sm:text-3xl font-bold mb-6 ${showModal ? 'text-center' : ''}`}>
            Get in Touch with Us
          </p>

          <form onSubmit={handleSubmit} className='grid grid-cols-1 sm:grid-cols-2 gap-4'>
            <input
              type='text'
              name='name'
              value={formData.name}
              onChange={handleChange}
              placeholder='Name'
              className='border h-[50px] p-2 rounded outline-none bg-[#ecf1f5] placeholder:text-gray-700'
              required
            />
            <input
              type='text'
              name='mobile'
              value={formData.mobile}
              onChange={handleChange}
              placeholder='Mobile Number'
              className='border h-[50px] p-2 rounded outline-none bg-[#ecf1f5] placeholder:text-gray-700'
              required
            />
            {/* <input
              type='email'
              name='email'
              value={formData.email}
              onChange={handleChange}
              placeholder='Email'
              className='border h-[50px] p-2 rounded outline-none bg-[#ecf1f5] placeholder:text-gray-700'
              required
            /> */}
            <input
              type='text'
              name='subject'
              value={formData.subject}
              onChange={handleChange}
              placeholder='Subject'
              className='border h-[50px] col-span-1 sm:col-span-2 p-2 rounded outline-none bg-[#ecf1f5] placeholder:text-gray-700'
              required
            />
            <textarea
              name='message'
              value={formData.message}
              onChange={handleChange}
              placeholder='Write message'
              className='border p-2 rounded outline-none col-span-1 sm:col-span-2 h-32 resize-none bg-[#ecf1f5] placeholder:text-gray-700'
              required
            />
            <button
              type='submit'
              className='col-span-1 sm:col-span-2 bg-orange-500 text-white py-3 px-6 rounded hover:bg-orange-600 transition-all duration-300 text-sm sm:text-base'
            >
              Get In Touch <FaArrowRight className='inline-block ml-2' />
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default GetInTouch;
